import React, { useState } from 'react';
import './RotatingLoader.css';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { useLoaderLogo } from './LoaderLogo';
import { optimizeImageUrl } from '../utils/orderPageImageUtils';

type RotatingLoaderProps = {
  useRegualarColor?: boolean;
  width?: string;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RotatingLoader = ({ useRegualarColor, width }: RotatingLoaderProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const logo = useLoaderLogo();
  const [failedLogo, setFailedLogo] = useState<string>();
  const showLogo = logo && logo !== failedLogo;
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid className="rotating-image">
        {showLogo ? (
          // Logos come in any aspect ratio and size: fit into a fixed square so the spin stays centered and bounded.
          <img
            src={optimizeImageUrl(logo, 200)}
            alt="Loading"
            style={{ display: 'block', width: width ?? '72px', height: width ?? '72px', objectFit: 'contain' }}
            onError={() => setFailedLogo(logo)}
          />
        ) : (
          <img src={`/favicon-rotating.png`} alt="Rotating logo" width={isSmallScreen ? undefined : width ?? '50px'} />
        )}
      </Grid>
    </Grid>
  );
};

export default RotatingLoader;
